//VERSION ESTABLE
import React, { useState } from 'react';
import { CgViewComfortable } from 'react-icons/cg';
import { useDispatch, useSelector } from 'react-redux';
import { addGroupToApi } from '../../store/grupo.actions'; // Asegúrate de tener esta acción en tu archivo de acciones
import '../../assets/styles/menu-grupomodal.css';
import { setDynamicModalObj2 } from "../../store/grupo.actions";

const projectData = [
    { id_proyecto: 1, nombre_proyecto: "DINAMICA" },
    { id_proyecto: 2, nombre_proyecto: "CDE/CIIE" },
];

export function AddGroupModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nombreGrupo, setNombreGrupo] = useState('');
    const currentBoard = useSelector((storeState) => storeState.boardModule.currentBoard);
    const [color, setColor] = useState('#ffffff'); // Inicializa con un color por defecto
    // const dispatch = useDispatch();

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const onSubmit = async (ev) => {
        ev.preventDefault();
        const newGroup = {
            nombre_grupo: nombreGrupo,
            estado: 1,
            fk_tableros_id: currentBoard.id_tablero, // Convierte a string si es necesario
            color: color || '#2149D4' // Usa color por defecto si no hay color seleccionado
        };
        try {
            (addGroupToApi(newGroup));
            closeModal();
        } catch (err) {
            console.error('Failed to add group:', err);
        }
    };

    return (
        <div className='add-group-modal'>
            <div className='add-group' onClick={openModal}>
                <CgViewComfortable className='icon' />
                <span>Nuevo Grupo</span>
            </div>
            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <form onSubmit={onSubmit}>
                            <h3>Agregar Grupo</h3>
                            <div>
                                <label>Grupo:</label>
                                <input
                                    type="text"
                                    value={nombreGrupo}
                                    onChange={(e) => setNombreGrupo(e.target.value)}
                                    required
                                />
                            </div>
                            <div>
                                <label>Tablero: </label>
                                <input
                                    type="text"
                                    value={currentBoard.nombre_tablero}
                                    readOnly // Campo de solo lectura
                                    required
                                />
                            </div>
                            <div>
                                <label>Color: </label>
                                <input
                                    type="color" // Cambiado a input de tipo color
                                    value={color}
                                    onChange={(e) => setColor(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit">Añadir Grupo</button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

//Version de prueba-----

// import React, { useState } from 'react';
// import { CgViewComfortable } from 'react-icons/cg';
// import { useDispatch, useSelector } from 'react-redux';
// import { addGroupToApi } from '../../store/grupo.actions'; // Asegúrate de tener esta acción en tu archivo de acciones
// import '../../assets/styles/menu-grupomodal.css';
// import { setDynamicModalObj2 } from "../../store/grupo.actions";


// export function AddGroupModal({ dynamicModalObj2 }) {
//     const dispatch = useDispatch();
//     const currentBoard = useSelector((storeState) => storeState.boardModule.currentBoard);
//     const [nombreGrupo, setNombreGrupo] = useState('');
//     const [color, setColor] = useState('#ffffff');

//     const closeModal = () => {
//         dispatch(setDynamicModalObj2({ ...dynamicModalObj2, isOpen: false }));
//     };

//     const onAddGroup = async (ev) => {
//         ev.preventDefault();
//         const newGroup = {
//             nombre_grupo: nombreGrupo,
//             estado: 1,
//             fk_tableros_id: currentBoard.id_tablero,
//             color: color || '#2149D4',
//         };
//         try {
//             await addGroupToApi(newGroup);
//             closeModal();
//         } catch (err) {
//             console.error('Failed to add group:', err);
//         }
//     };

//     return (
//         <div className='add-group-modal'>
         
//                 <div className="modal-overlay" onClick={closeModal}>
//                     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//                         <form onSubmit={onAddGroup}>
//                             <h3>Agregar Grupo</h3>
//                             <div>
//                                 <label>Grupo:</label>
//                                 <input
//                                     type="text"
//                                     value={nombreGrupo}
//                                     onChange={(e) => setNombreGrupo(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                             <div>
//                                 <label>Tablero: </label>
//                                 <input
//                                     type="text"
//                                     value={currentBoard.nombre_tablero}
//                                     readOnly
//                                     required
//                                 />
//                             </div>
//                             <div>
//                                 <label>Color: </label>
//                                 <input
//                                     type="color"
//                                     value={color}
//                                     onChange={(e) => setColor(e.target.value)}
//                                     required
//                                 />
//                             </div>
//                             <button type="submit">Añadir Grupo</button>
//                         </form>
//                     </div>
//                 </div>
            
//         </div>
//     );
// }



//-----CODIGO ORIGINAL-------

// import React from 'react'
// import { BsArrowDownCircle } from 'react-icons/bs'
// import { CgViewComfortable } from 'react-icons/cg'
// import { useSelector } from 'react-redux'
// import { addGroup, setDynamicModalObj } from '../../store/board.actions'

// export function AddGroupModal({ dynamicModalObj }) {
//     const board = useSelector(storeState => storeState.boardModule.filteredBoard)

//     function onAddGroup() {
//         try {
//             addGroup(board)
//             dynamicModalObj.isOpen = false
//             setDynamicModalObj(dynamicModalObj)
//         } catch (err) {
//             console.log('cant add group:', err)
//         }
//     }
//     return (
//         <div className='add-group-modal'>
//             <div className='add-group' onClick={onAddGroup}>
//                 <CgViewComfortable className='icon' />
//                 <span>New group of Tasks</span>
//             </div>
//             <div className='import-tasks'>
//                 <BsArrowDownCircle className='icon' />
//                 <span>Import tasks</span>
//             </div>
//         </div>
//     )
// }
